import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_DISHES,
  REQUEST_CREATE_MASTER_DISHES,
  SET_MASTER_DISHES,
  SUCCESS_CREATE_MASTER_DISHES,
  ERROR_GET_MASTER_DISHES,
  ERROR_CREATE_MASTER_DISHES,
  SET_MESSAGE_MASTER_DISHES,
  SUCCESS_DELETE_MASTER_DISHES,
  SUCCESS_UPDATE_MASTER_DISHES,
  REQUEST_DELETE_MASTER_DISHES,
  REQUEST_UPDATE_MASTER_DISHES,
  ERROR_DELETE_MASTER_DISHES,
  ERROR_UPDATE_MASTER_DISHES,
} from "./dishesActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterDishes: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterDishes: [],
};

const dishes = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_DISHES:
    case REQUEST_CREATE_MASTER_DISHES:
    case REQUEST_DELETE_MASTER_DISHES:
    case REQUEST_UPDATE_MASTER_DISHES:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_DISHES:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_DISHES:
      return {
        ...state,
        busy: false,
        message: "",
        masterDishes: action.payload,
      };

    case SUCCESS_CREATE_MASTER_DISHES:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        masterDishes: [...state.masterDishes, action.payload],
      };
    case SUCCESS_DELETE_MASTER_DISHES:
      return {
        ...state,
        busy: false,
        message: "",
        masterDishes: state.masterDishes.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_DISHES:
      return {
        ...state,
        busy: false,
        message: "",
        masterDishes: state.masterDishes.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_DISHES:
    case ERROR_CREATE_MASTER_DISHES:
    case ERROR_UPDATE_MASTER_DISHES:
    case ERROR_DELETE_MASTER_DISHES:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default dishes;

export function useDishesMaster() {
  return useSelector((state: Record<string, any>) => state.dishes);
}
